interface ClipboardListIconProps {
  width?: number;
  height?: number;
  fill?: string;
}

const ClipboardListIcon: React.FC<ClipboardListIconProps> = ({
  width = 16,
  height = 16,
  fill = "white",
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.33984 10.0001C5.70803 10.0001 6.00651 10.2986 6.00651 10.6667C6.00651 11.0349 5.70803 11.3334 5.33984 11.3334H5.33333C4.96514 11.3334 4.66667 11.0349 4.66667 10.6667C4.66667 10.2986 4.96514 10.0001 5.33333 10.0001H5.33984ZM10.6667 10.0001C11.0349 10.0001 11.3333 10.2986 11.3333 10.6667C11.3333 11.0349 11.0349 11.3334 10.6667 11.3334H8C7.63181 11.3334 7.33333 11.0349 7.33333 10.6667C7.33333 10.2986 7.63181 10.0001 8 10.0001H10.6667ZM5.33984 6.66675C5.70803 6.66675 6.00651 6.96522 6.00651 7.33341C6.00651 7.7016 5.70803 8.00008 5.33984 8.00008H5.33333C4.96514 8.00008 4.66667 7.7016 4.66667 7.33341C4.66667 6.96522 4.96514 6.66675 5.33333 6.66675H5.33984ZM10.6667 6.66675C11.0349 6.66675 11.3333 6.96522 11.3333 7.33341C11.3333 7.7016 11.0349 8.00008 10.6667 8.00008H8C7.63181 8.00008 7.33333 7.7016 7.33333 7.33341C7.33333 6.96522 7.63181 6.66675 8 6.66675H10.6667ZM10 2.00008H6V3.33341H10V2.00008ZM11.3333 3.33341C11.3333 4.06979 10.7364 4.66675 10 4.66675H6C5.26362 4.66675 4.66667 4.06979 4.66667 3.33341H4C3.82319 3.33341 3.65367 3.4037 3.52865 3.52873C3.40362 3.65375 3.33333 3.82327 3.33333 4.00008V13.3334L3.33659 13.3992C3.35172 13.5518 3.41922 13.6953 3.52865 13.8048C3.65367 13.9298 3.82319 14.0001 4 14.0001H12C12.1768 14.0001 12.3463 13.9298 12.4714 13.8048C12.5964 13.6797 12.6667 13.5102 12.6667 13.3334V4.00008C12.6667 3.82327 12.5964 3.65375 12.4714 3.52873C12.3619 3.4193 12.2184 3.3518 12.0658 3.33667L12 3.33341H11.3333ZM12 2.00008C12.5304 2.00008 13.039 2.21095 13.4141 2.58602C13.7891 2.96109 14 3.46965 14 4.00008V13.3334C14 13.8638 13.7891 14.3724 13.4141 14.7475C13.039 15.1225 12.5304 15.3334 12 15.3334H4C3.46957 15.3334 2.96101 15.1225 2.58594 14.7475C2.21086 14.3724 2 13.8638 2 13.3334V4.00008C2 3.46965 2.21086 2.96109 2.58594 2.58602C2.96101 2.21095 3.46957 2.00008 4 2.00008H4.66667C4.66667 1.2637 5.26362 0.666748 6 0.666748H10C10.7364 0.666748 11.3333 1.2637 11.3333 2.00008H12Z"
        fill={fill}
      />
    </svg>
  );
};

export default ClipboardListIcon;
